<template>
  <modal
    :variant="isMobile ? 'mobile-swipe' : 'drawer'"
    custom-footer
    customClass="room-upgrade-modal"
    @input="handleOpenModal"
    @close="handleCloseModal"
  >
    <template v-slot:default="{ activate }">
      <slot v-bind="{ activate }" />
    </template>

    <template v-slot:header>
      <div class="modal-title">
        <span>{{tc('booking.upgradeRoom')}}</span>
      </div>
    </template>

    <template v-slot:body="{ isActive }">
      <roomUpgradeModalBody v-bind="{ isActive }"/>
    </template>

    <template v-slot:footer="{ deactivate }">
      <roomUpgradeModalFooter @close="deactivate"/>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import roomUpgradeModalBody from "./components/room-upgrade-modal-body.vue";
import roomUpgradeModalFooter from "./components/room-upgrade-modal-footer.vue";
export default {
  name: "room-upgrade-modal",
  components: {
    roomUpgradeModalBody,
    roomUpgradeModalFooter
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapState('responsive', ['width']),
    isMobile() {
      return this.width <= 767
    },
  },
  methods: {
    handleCloseModal() {
      document.body.classList.remove('no-scroll')

    },
    handleOpenModal() {
      document.body.classList.add("no-scroll")
    },
  }
};
</script>
